<template>
  <AuthPageContainer>
    <template #header>
      {{ $t("password_recovery.title") }}
    </template>

    <div class="gap-row-1xs w-100" v-if="stage == 0">
      <div class="qrw-label-sm bold v1-grey-6-color">
        {{ $t("register.email_ph") }}
      </div>

      <BaseInput v-model="restore_email" fullWidth type="email" />
    </div>

    <div class="gap-row-xs w-100" v-if="stage == 0">
      <BaseButton
        variant="primary"
        :disabled="!restore_email || busy"
        @click="sendRestore"
        size="lg"
        color="green-5"
      >
        {{ $t("password_recovery.restore_btn") }}
      </BaseButton>

      <BaseButton
        variant="tertiary"
        size="lg"
        @click="$router.push('/login')"
        color="v1-grey-10"
      >
        {{ $t("password_recovery.back_btn") }}
      </BaseButton>
    </div>

    <img
      src="/icons/green-skate-panda.svg"
      v-if="stage == 1"
      class="skate-panda"
    />

    <div
      class="qrw-heading-xs bold green-5-color w-100 recovery-login-text"
      v-if="stage == 1"
    >
      {{ $t("password_recovery.sent_mail") }}
    </div>

    <BaseButton
      variant="tertiary"
      size="lg"
      @click="$router.push('/login')"
      color="v1-grey-10"
      v-if="stage == 1"
    >
      {{ $t("password_recovery.back_btn") }}
    </BaseButton>

    <div class="gap-row-sm w-100" v-if="stage == 2">
      <div class="w-100 gap-row-1xs">
        <div class="w-100 qrw-label-sm bold v1-grey-6-color">
          {{ $t("confirm_register.create_password") }}
        </div>
        <BaseInput
          type="password"
          v-model="restore_form.password"
          fullWidth
        />
      </div>
      <div class="w-100 gap-row-1xs">
        <div class="w-100 qrw-label-sm bold v1-grey-6-color">
          {{ $t("confirm_register.repeat_password") }}
        </div>
        <BaseInput
          type="password"
          v-model="restore_form.repeat"
          fullWidth
        />
      </div>
      <PasswordMeter :value="restore_form.password"/>
      <BaseDivider color="v1-grey-4"/>
      <BaseButton
        variant="primary"
        :disabled="!restore_form.password || restore_form.password != restore_form.repeat || busy"
        @click="resetPassword"
        size="lg"
        color="green-5"
      >
        {{ $t("password_recovery.restore_btn") }}
      </BaseButton>
    </div>
  </AuthPageContainer>
</template>

<script>
import AuthPageContainer from "@/components/AuthPageContainer.vue";

import PasswordMeter from "@/components/PasswordMeter.vue"

import AuthAPI from "@/api/auth";

export default {
  components: {
    AuthPageContainer,
    PasswordMeter
  },
  data() {
    return {
      restore_email: null,

      restore_key: null,

      restore_form: {
          password: null,
          repeat: null
      },

      stage: 0,

      busy: false,
    };
  },
  methods: {
    sendRestore() {
      if (this.busy) return;

      this.busy = true;

      AuthAPI.forgotPassword(this.restore_email)
        .then(() => {
          this.busy = false;
          this.stage = 1;
        })
        .catch((error) => {
          console.error(error);
          alert(`Error :(`);
          this.busy = false;
        });
    },
    resetPassword() {
      if (this.busy) return;

      this.busy = true;

      AuthAPI.resetPassword(this.restore_key, this.restore_form.password)
        .then(() => {
          window.location.href = 'https://dashboard.qrwaiter.com.ua';
        })
        .catch((error) => {
          this.busy = false;
        });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.restore_key = this.$route.params.id;
      this.stage = 2;
    }
  },
};
</script>

<style scoped>
.skate-panda {
  width: 150px;
  height: 150px;
  max-width: 150px;
  min-width: 150px;
  max-height: 150px;
}

.recovery-login-text {
  text-align: center;
}
</style>